import { createSelector } from '@ngrx/store';

import { selectProductState } from './product-selection.selectors';

export const selectProductScoreCardState = createSelector(
  selectProductState,
  (state) => state.scoreCard,
);

export const selectProductScoreCardSkuData = createSelector(
  selectProductScoreCardState,
  (state) => state.skuData,
);
